import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class CalculadoraService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/calculadora/'
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/planet-dev/src/app/shared/services/api/calculadora.service.ts